<template>
  <table class="table tablesorter" :class="tableClass" :aria-busy="loading">
    <thead :class="theadClasses">
      <tr>
        <slot name="columns" :columns="columns">
          <th v-for="column in columns" :key="column.key || column.label" scope="col" :class="{ 'sortable': column.sorting, 'sort-active': sortBy === column.key }" :aria-sort="column.sorting ? (sortBy === column.key ? (sortDirection === 'desc' ? 'descending' : 'ascending') : 'none') : undefined">
            <button v-if="column.sorting" class="table-sort-button" type="button" :disabled="loading" @click="sortByColumn(column)">
              {{ $t(column.label) }}
              <i :class="sortBy === column.key ? (sortDirection === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up') : 'fa fa-sort'" aria-hidden="true"></i>
            </button>
            <template v-else>{{ $t(column.label) }}</template>
          </th>
        </slot>
      </tr>
    </thead>
    <tbody :class="tbodyClasses">
      <tr v-if="data.length === 0">
        <td :colspan="100" class="table-state-cell">
          <div v-if="loading" class="table-state" role="status">
            <span class="spinner-border text-primary" aria-hidden="true"></span>
            <strong>{{ $t("experience.loading") }}</strong>
          </div>
          <div v-else class="table-state" role="status">
            <i class="fa fa-inbox" aria-hidden="true"></i>
            <strong>{{ emptyTitle || $t("experience.emptyTitle") }}</strong>
            <p>{{ emptyDescription || $t("experience.emptyDescription") }}</p>
            <slot name="empty-action"></slot>
          </div>
        </td>
      </tr>
      <tr v-for="(item, index) in data" :key="item.id || index">
        <slot :item="item">
          <td v-for="column in columns" :key="column">
            <template v-if="hasValue(item, column)">
              {{ itemValue(item, column) }}
            </template>
          </td>
        </slot>
      </tr>
    </tbody>
    <tfoot v-if="$slots.footer || (paginated && !listFull && data.length > 0)">
        <slot name="footer">
          <tr class="text-center">
            <td :colspan="100">
              <template v-if="paginated && !listFull && !(data.length === 0 && loading === false)">
                <base-button v-if="!loading" :outline="true" size="sm" type="primary" @click="loadMore">{{ $t("Load more") }}</base-button>
                <span v-else role="status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> {{ $t("experience.loading") }}</span>
              </template>
            </td>
          </tr>
        </slot>
    </tfoot>
  </table>
</template>
<script>
import {getAnalytics, logEvent} from "firebase/analytics"
export default {
  name: "base-table",
  props: {
    emptyTitle: { type: String, default: "" },
    emptyDescription: { type: String, default: "" },
    columns: {
      type: Array,
      default: () => [],
      description: "Table columns",
    },
    pagination: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false,
    },
    listFull: {
      type: Boolean,
      default: false,
    },
    paginated: {
      type: Boolean,
      default: false,
    },
    fetchMore: {
      type: Function
    },
    data: {
      type: Array,
      default: () => [],
      description: "Table data",
    },
    sortBy: {
      type: String,
      description: "sorting field",
    },
    sortDirection: {
      type: String,
      description: "sort table direction asc or desc",
    },
    type: {
      type: String, // striped | hover
      default: "",
      description: "Whether table is striped or hover type",
    },
    theadClasses: {
      type: String,
      default: "",
      description: "<thead> css classes",
    },
    tbodyClasses: {
      type: String,
      default: "",
      description: "<tbody> css classes",
    },
  },
  emits: ["fetchMore", "update:loading", "sort"],
  data() {
    return {
    }
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`
    },
    colsWithValue() {
      return (row) => {
        return this.columns.filter((column) => this.hasValue(row, column))
      }
    },
  },
  methods: {
    empty(){},
    loadMore(){
      const analytics = getAnalytics()
      logEvent(analytics, "click", {
        item_id: "load_more",
        page_title: this.$route.name
      })

      this.$emit("update:loading", true)
      this.$emit("fetchMore")
    },
    sortByColumn(column){
      this.$emit("update:loading", true)
      this.$emit("sort", {field: column.key, order: this.sortDirection === "asc" ? "desc" : "asc"}, true)
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined"
    },
    itemValue(item, column) {
      return item[column.toLowerCase()]
    },
  },
}
</script>
<style>
.table .thead-light th.sortable{
  cursor: pointer;
}
th.sortable.sort-active {
  background: #ebeced !important;
}
</style>
